import React from "react";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";
import { useDesignTokens } from "../../../theme/useDesignTokens";

const AppRadioGroup = ({
  value = "",
  onChange,
  options = [],
  row = false,
  name,
  label,
  disabled = false,
  size = "small",
  fullWidth = true,
  sx = {},
  formControlSx = {},
  radioGroupSx = {},
  optionLabelSx = {},
  radioSx = {},
  ...props
}) => {
  const { colors, font } = useDesignTokens();
  const primaryColor = colors?.primary?.main || "#ED6C02";

  return (
    <FormControl fullWidth={fullWidth} sx={formControlSx}>
      {label ? (
        <Typography
          variant="body2"
          sx={{ mb: 1, fontWeight: font?.weight?.fontW600 }}
        >
          {label}
        </Typography>
      ) : null}
      <RadioGroup
        row={row}
        name={name}
        value={value}
        onChange={onChange}
        sx={{ alignItems: row ? "center" : "flex-start", ...sx }}
        {...props}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            disabled={disabled || option.disabled}
            control={
              <Radio
                size={size}
                sx={{
                  color: primaryColor,
                  "&.Mui-checked": {
                    color: primaryColor,
                  },
                  ...radioSx,
                }}
              />
            }
            label={option.label}
            sx={{
              m: 0,
              mr: row ? 2 : 0,
              alignItems: "center",
              "& .MuiFormControlLabel-label": {
                fontWeight: font?.weight?.fontW500,
                ...optionLabelSx,
              },
              ...radioGroupSx,
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default AppRadioGroup;
